module.exports = __webpack_public_path__ + "img/vegetable-sorrel-350x184.5994f408.jpg";